// src/cartStore.js
import { persistentAtom } from '@nanostores/persistent'
import { atom } from 'nanostores'

export const isCartOpen = atom(false)

export const cartData = persistentAtom(
    'cart',
    {},
    {
        encode(cartObj) {
            return JSON.stringify(cartObj)
        },
        decode(cartObj) {
            return JSON.parse(cartObj)
        },
    }
)
